import { RouteConfig } from 'vue-router';
import BetaProgram from './components/beta-program.vue';

export const betaProgram: RouteConfig = {
  path: 'beta-software',
  component: BetaProgram,
};
